import Vue from 'vue'
import { abilitiesPlugin } from '@casl/vue'
import ability from '@/libs/acl/ability'

Vue.use(abilitiesPlugin, ability)
